<template>
  <el-dialog
    width=500px
    class="dialog"
    :visible.sync="visible"
    :close-on-click-modal='false'
    :show-close='false'
    top="20vh"
  >
    <span slot="title" class="dialog-title">
      {{ title }}
    </span>
    <textarea
      class="inputStyle"
      style="width: 450px; height: 150px"
      placeholder='請填寫您期望的選項，以供我們作為下一版選項的參考'
      v-model="emailContent">
    </textarea>
    <p>
      您的反饋將幫助我們提供更符合<br>廣告主需求的AI-powered廣告規劃工具
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="sendFeedBack">送出</el-button>
      <el-button @click="closeDialog()">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import user from '@/api/user'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    emailTitle: {
      type: String
    }
  },
  data () {
    return {
      emailContent: ''
    }
  },
  methods: {
    sendFeedBack () {
      user.sendFeedback(this.emailTitle, this.emailContent)
        .then(res => {
          this.emailContent = ''
          this.closeDialog()
          this.$alert('已送出!')
        })
        .catch(err => {
          this.$alert(`送出失敗 ${err}`)
        })
    },
    closeDialog () {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__header {
    background: #4da1ff;
    height: 40px;
    width: 100%;
    text-align: center;
    display:  flex;
    align-items: center;
    justify-content:  center;
  }
  .dialog-title {
    color: #ffffff;
    margin-top: -10px;
  }
  .inputStyle {
    width: 377px;
    height: 83px;
    border-radius: 4px;
    border: solid 1px #c6c6c6;
    background-color: #ffffff;
  }
</style>
